import React from 'react'
import { Col, Container, Row } from 'react-bootstrap';
import "./case-disclaimer.css"
import { useTranslation } from 'react-i18next';
import { Checkbox, IconBriefcaseWithBuckle, IconLaptop3D, IconWarningAlt , RadioGroup, RadioButton} from "@veneer/core";

interface DisclaimerFormData {
    consentAcknowledgement: boolean;
    osReinstallationConsent: string;
}

interface CaseDisclaimerProps {
    adpValue?: string;
    isADP?: string | null;
    onChange?: (data: {
    allowSubmit: boolean;
    consentValue: string;
    osConsentValue: string;
}) => void;
    isOpen?: boolean;
}

function CaseDisclaimer({ adpValue, isADP, onChange, isOpen }: CaseDisclaimerProps) {
    const { t } = useTranslation();
    const [disclaimerFormData, setDisclaimerFormData] = React.useState<DisclaimerFormData>({
        consentAcknowledgement: false,
        osReinstallationConsent: ""
    });
    const showPCDisclaimer = sessionStorage.getItem("isPC") === "true";
    const showCustomerAvailability = sessionStorage.getItem("isCustomerAvailability") === "true";
    const isPoly = sessionStorage.getItem("isPoly");
    const isPolyAllowed = isPoly === null || isPoly === "false";

    React.useEffect(() => {
        if (isOpen) {
            setDisclaimerFormData({
                consentAcknowledgement: false,
                osReinstallationConsent: ""
            });
        }
    }, [isOpen]);

    React.useEffect(() => {
        var allowSubmit = false;
        if (showPCDisclaimer){
            allowSubmit = disclaimerFormData.consentAcknowledgement == true && (disclaimerFormData.osReinstallationConsent == "1" || disclaimerFormData.osReinstallationConsent == "0");
        }else{
            allowSubmit = disclaimerFormData.consentAcknowledgement == true;
        }
        onChange?.({
    allowSubmit,
    consentValue: disclaimerFormData.consentAcknowledgement ? "Yes" : "No",
    osConsentValue:
        disclaimerFormData.osReinstallationConsent === "1"
            ? "Yes"
            : disclaimerFormData.osReinstallationConsent === "0"
            ? "No"
            : ""
});
    },[disclaimerFormData]);

    const showADPDisclaimer = adpValue === "Yes" && isADP === "true";
    return (
        <Container className='case-disclaimer-container d-flex flex-column gap-2'>
            <div className="gap-3 d-flex flex-column border disclaimer-box">
                <div className='Section-header px-3'>
                    <div className="d-flex flex-row align-items-center gap-2">
                        <IconBriefcaseWithBuckle color="white" size={48} />
                        <span>{t("HPI.CreateCase.ConsentForAllCustomers", {defaultValue: "Consent for All Customers"})}</span> &nbsp;&nbsp; <span className='lowerText'>{t("HPI.CreateCase.RequiredAcknowledgement", {defaultValue: "Required Acknowledgement"})}</span>
                    </div>
                </div>
                <Checkbox
                className='px-4'
                    id="checkbox"
                    checked={disclaimerFormData.consentAcknowledgement}
                    onChange={(e) => {setDisclaimerFormData({ ...disclaimerFormData, consentAcknowledgement: e.target.checked });}}
                    label= {<span>{t("HPI.CreateCase.ConsentAcknowledgement", {defaultValue: "By checking this box, I acknowledge that HP is not responsible for the loss of data, programs, or any confidential, personal, or proprietary information on the device being shipped."})} <br /><span style={{ display: 'block', marginTop: '0.3rem' }}></span>{t("HPI.CreateCase.DataBackupResponsibility", {defaultValue: "I am responsible for backing up my data prior to service."})}</span>}
                />
                <hr className='mx-4 my-0' />
                <div className='px-4'>
                    <p className='mb-0'>{t("HPI.CreateCase.SupportRepresentativeContact", {defaultValue: "An HP Support Representative may contact me for further information or troubleshooting."})}<br />
                    {t("HPI.CreateCase.EmailResponse", {defaultValue: "If contacted by email, I will respond promptly to help avoid delays in service or case closure."})}</p>
                    <hr className='my-2' />
                    <p className='mb-0'>{t("HPI.CreateCase.SharingPhotos", {defaultValue: "I understand that sharing photos or configuration details may help expedite my service request."})}</p>
                    <hr className='my-2' />
                    <p className='mb-3 impInfo'>{t("HPI.CreateCase.ConsentRequired", {defaultValue: "* This consent must be accepted to proceed."})}</p>
                </div>
            </div>
            { showADPDisclaimer && <div className="gap-3 d-flex flex-column border disclaimer-box">
                <div className='Section-header px-3'>
                    <div className="d-flex flex-row align-items-center gap-2">
                        <IconWarningAlt color="white" size={48} />
                        <span>{t("HPI.CreateCase.ADPCustomersOnly", {defaultValue: "ADP Customers Only"})}</span>
                    </div>
                </div>
                <div className='px-4'>
                    <p className='mb-0' style={{fontWeight: 'bold', color: '#015985'}}>{t("HPI.CreateCase.AccidentalDamageProtectionDisclaimer", {defaultValue: "Accidental Damage Protection Disclaimer"})}</p>
                    <hr className='my-2' />
                    <p className='mb-0'>{t("HPI.CreateCase.ADPClaimsRequireCompleteDamageDescriptions", {defaultValue: "ADP claims require complete damage descriptions and clear photo evidence."})}</p>
                    <hr className='my-2' />
                    <p className='mb-0'>{t("HPI.CreateCase.IfInformationIsIncompleteOrUnclear", {defaultValue: "If information is incomplete or unclear, an HP agent will contact you."})}</p>
                    <hr className='my-2' />
                    <p className='mb-3'>{t("HPI.CreateCase.ADPClaimProcessing", {defaultValue: "Your ADP claim will not be processed until all required information is received."})}</p>
                </div>
            </div>}
            {showCustomerAvailability && isPolyAllowed && <div className="gap-3 d-flex flex-column border disclaimer-box">
                <div className='Section-header px-3'>
                    <div className="d-flex flex-row align-items-center gap-2">
                        <IconWarningAlt color="white" size={48} />
                        <span>{t("HPI.Create.Case.Customeravailabilitytitle", {defaultValue: "Customer Availability (If Applicable)"})}</span>
                    </div>
                </div>
                <div className='px-4'>
                    <p className='mb-2'>{t("HPI.CreateCase.CustomerAvailabilityDisclaimerLine1", {defaultValue: "Your availability is requested only to support scheduling if an onsite visit is required. It will not be used for frequent contact."})}</p>
                    {/* <hr className='my-2' /> */}
                    {/* <p className='mb-0'>{t("HPI.CreateCase.CustomerAvailabilityDisclaimerLine2", {defaultValue: "Final onsite schedule depends on eligibility, parts availability, and technician assignment."})}</p> */}
                </div>
            </div>}
               
            {showPCDisclaimer && <div className="gap-3 d-flex flex-column border disclaimer-box">
                <div className='Section-header px-3'>
                    <div className="d-flex flex-row align-items-center gap-2">
                        <IconLaptop3D color="white" size={48} />
                        <span>{t("HPI.CreateCase.OSReinstallationConsent", {defaultValue: "OS Reinstallation Consent (PC Devices)"})}</span>
                    </div>
                </div>
                <div className='px-4'>
                    <p className='mb-0'>{t("HPI.CreateCase.OSReinstallationConsentDescription", {defaultValue: "If a repair service is needed, do you consent to the operating system being reinstalled?"})}</p>
                </div>
                <div className='px-4'>
                    <RadioGroup 
                        alignment="horizontal" 
                        id="os-radio-id" 
                        name="radiobutton"
                        value={disclaimerFormData.osReinstallationConsent}
                        onChange={(e) => {setDisclaimerFormData({ ...disclaimerFormData, osReinstallationConsent: e.target.value });}}
                    >
                        <RadioButton
                            id="radio1-id" value="1" label="Yes" />
                        <RadioButton
                            id="radio2-id" value="0" label="No" />
                    </RadioGroup>
                </div>
                <div className='px-4'>
                    <hr className='m-0' />
                    <p className='mt-2 mb-3 impInfo'>{t("HPI.CreateCase.ASelectionIsRequiredBeforeProceeding", {defaultValue: "* A selection is required before proceeding."})}</p>
                </div>
            </div>}
            
        </Container>
    )
}

export default CaseDisclaimer;